import React, { useState, useEffect } from "react";
import { Card, Container, CardBody, CardSubtitle, CardTitle, CardText, ModalBody, Modal } from "reactstrap";
import TuneIcon from '@mui/icons-material/Tune';
import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import { Autocomplete, Checkbox } from "@mui/material";
import { TextField } from "@mui/material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import ReplayIcon from '@mui/icons-material/Replay';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { styled } from '@mui/system';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Input as BaseInput } from '@mui/base/Input';
import {fetchPOForGRN} from "../../../api/grn"
import { toast } from "react-toastify";
import Button from '@mui/material/Button';
import dayjs from "dayjs";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { StorePageHeaderName } from "../../../store/pageHeader/action";
import { useDispatch } from "react-redux";

const blue = {
    100: '#DAECFF',
    200: '#b6daff',
    400: '#3399FF',
    500: '#007FFF',
    600: '#0072E5',
    900: '#003A75',
};

const grey = {
    50: '#F3F6F9',
    100: '#E5EAF2',
    200: '#DAE2ED',
    300: '#C7D0DD',
    400: '#B0B8C4',
    500: '#9DA8B7',
    600: '#6B7A90',
    700: '#434D5B',
    800: '#303740',
    900: '#1C2025',
};

const InputElement = styled('input')(
    ({ theme }) => `
    width: 120px;
    font-family: 'IBM Plex Sans', sans-serif;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    padding: 8px 12px;
    border-radius: 4px;
    color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
    background: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
    border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
    box-shadow: 0px 2px 4px ${theme.palette.mode === 'dark' ? 'rgba(0,0,0, 0.5)' : 'rgba(0,0,0, 0.05)'
        };
  
    &:hover {
      border-color: ${blue[400]};
    }
  
    &:focus {
      border-color: ${blue[400]};
      box-shadow: 0 0 0 3px ${theme.palette.mode === 'dark' ? blue[600] : blue[200]};
    }
  
    // firefox
    &:focus-visible {
      outline: 0;
    }
  `,
);
const GRN = () => {

    const dispatch = useDispatch();
    dispatch(StorePageHeaderName('GRN'))

    const [isMount, setIsMount] = useState(false);
    const [showList, setShowList] = useState(false);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [fromDate, setFromDate] = useState(null)
    const [toDate, setToDate] = useState(null)
    const [poDropdownList, setPODropDownList] = useState([]);
    const [selectedPo, setSelectedPo] = useState(null);
    const [result, setResult] = useState([]);
    const [approvalrows, setApprovalRows] = useState([]);
    const [open, setOpen] = useState(false);
    const [errors, setErrors] = useState({
        from_date: false,
        to_date: false
    });   

    const Input = React.forwardRef(function CustomInput(props, ref) {
        return <BaseInput slots={{ input: InputElement }} {...props} ref={ref} />;
    });
    document.title = "Kutchina GRN";

    const columns = [
        {
            field: 'Sl_No', headerName: 'Sl.No', flex: .5,
            resizable: false,
            sortable: false,
        },
        // {
        //     field: 'erp_po_no',
        //     headerName: 'PO NO',
        //     headerClassName: 'break-header',
        //     cellClassName: 'product_name_wrap',
        //     headerAlign: 'center',
        //     cellClassName: 'center-aligndata',
        //     // width: 160,
        //     editable: false,
        //     resizable: false,
        //     sortable: false,
        //     flex: 1,
        // },
        // {
        //     field: 'item_name',
        //     headerName: 'Item Name',
        //     headerClassName: 'break-header',
        //     cellClassName: 'product_name_wrap',
        //     headerAlign: 'center',
        //     cellClassName: 'center-aligndata',
        //     // width: 160,
        //     editable: false,
        //     resizable: false,
        //     sortable: false,
        //     flex: 1,
        // },
        {
            field: 'item_name',
            headerName: 'Item Name',
            headerClassName: 'break-header',
            cellClassName: 'product_name_wrap',
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            // width: 160,
            editable: false,
            resizable: false,
            sortable: false,
            flex: 1,
        },
        {
            field: 'quantity',
            headerName: 'Quantity',
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            // width: 160,
            editable: false,
            resizable: false,
            sortable: false,
            flex: .8,
        },
        {
            field: 'received_qty',
            headerName: 'Received Quantity',
            headerClassName: 'table-header-background',
            sortable: false,
            resizable: false,
            // width: 160,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            flex: .8,
        },
        {
            field: 'remaining_qty',
            headerName: 'Remaining QTY',
            headerClassName: 'table-header-background',
            sortable: false,
            resizable: false,
            // width: 160,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            flex: .8,
        },
    ];

    const fetchPOList = async(dateObj) =>{
        try {
            setOpen(true)
            const response = await fetchPOForGRN(dateObj)
            if(response.statusCode === 200){
                const res = response.data.polist
                const poDropDown = res.map(item => ({
                    label: item.PONUMBER,
                    value: item.id
                }));
                setPODropDownList(poDropDown)
                setResult(res)
            }
        }
        catch(error){
            console.log('error in fetching po list', error)
            toast.error('error in fetching po list')
        }
        finally{
            setOpen(false)
        }
    }
    const handleFromDateChange = (date) => {
        setFromDate(date);
        setErrors(prev => ({ ...prev, from_date: !date }));

      };
      const handleToDateChange = (date) => {
        setToDate(date);
        setErrors(prev => ({ ...prev, to_date: !date }));

      };
      const handleSubmit = () => {
        let formIsValid = true;

        if (!fromDate) {
            setErrors(prev => ({ ...prev, from_date: true }));
            formIsValid = false;
        }
        if (!toDate) {
            setErrors(prev => ({ ...prev, to_date: true }));
            formIsValid = false;
        }
        if (formIsValid) {

            fetchPOList({from_date: dayjs(fromDate).format('YYYY-MM-DD'),to_date: dayjs(toDate).format('YYYY-MM-DD')});
        }

    };
    const fetchPODetails = (erp_po_id) => {
        setIsMount(true)
        const selectedPOData = result.find((item) => item.id === erp_po_id);
        if (selectedPOData) {
          const rows = selectedPOData.procurementErpPOProducts.map((item, index) => ({
            id: item.id,
            Sl_No: index + 1,
            erp_po_no: selectedPOData.PONUMBER,
            item_name: item.item_name,
            total_po_quantity: item.OQORDERED,
            total_grn_received_qty: item.grn_received_qty,
            remaining_qty: item.OQORDERED -item.grn_received_qty,
            vendor_name: selectedPOData.VDNAME
          }));
          setApprovalRows(rows);
        } else {
          setApprovalRows([]);
        }
        setIsMount(false)
      };
      const handlePoChange = (event, value) => {
        setSelectedPo(value);
        if (value) {
          fetchPODetails(value.value);
        } else {
          setApprovalRows([]);
        }
      };
      const handleClose = () => {
        setOpen(false);
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div>
                        {/* <Backdrop
                            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                            open={open}
                            onClick={handleClose}
                        >
                            <CircularProgress color="inherit" />
                        </Backdrop> */}
                           <div className='d-flex align-items-center  justify-content-between mb-2 gap-2 flex-wrap'>
                                        <div className="d-flex align-items-center gap-2">
                                            <p className='mb-0 me-2 requisition_type_text'>GRN</p>
                                            <div>
                                            <Autocomplete
                                                className="invoice_autofield"
                                                // id={`product-category`}
                                                sx={{ width: 230 }}
                                                // options={taggingOptions}
                                                // value={selectedPO}
                                                // onChange={(e, value) => {
                                                //     setSelectedPO(value);
                                                // }}
                                                // onChange={handleProductCategoryChange}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Select Po"
                                                    />
                                                )}
                                            />

                                        </div>
                                            </div>
                                    </div>
                        {/* <Card>
                        <CardBody>
                        <div className="d-flex align-items-center gap-2">
                        <p className='mb-0 me-2' style={{color:'#545B69',fontSize:'15px', fontWeight:'500'}}>FROM :</p>

                            <div>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                                    id={`grn-from-date`}
                                                    className='invoice_datepicker'
                                                    label="From date"
                                                    value={fromDate}
                                                    onChange={handleFromDateChange}
                                                    sx={{ width: 200 ,background:'white' }}
                                                />
                                </LocalizationProvider>
                                {errors.from_date && <div style={{ color: 'red' }}>From date is required</div>}
                            </div>
                            <p className='mb-0 me-1 ms-2' style={{color:'#545B69',fontSize:'15px', fontWeight:'500'}}>TO :</p>

                            <div className="me-1">
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                                    id={`grn-to-date`}
                                                    className='invoice_datepicker'
                                                    label="To date"
                                                    value={toDate}
                                                    onChange={handleToDateChange}
                                />
                                {errors.to_date && <div style={{ color: 'red' }}>To date is required</div>}

                                </LocalizationProvider>
                            </div>
                            <button variant="contained" className="assign_vendor" onClick={handleSubmit}>Submit</button>

                            <p className='mb-0 me-2' style={{color:'#545B69',fontSize:'15px', fontWeight:'500'}}>PO NUMBER</p>
                            <div>
                            <Autocomplete
                                className="invoice_autofield"
                                id={`grn-po-list`}
                                sx={{ width: 200 }}
                                options={poDropdownList}
                                value={selectedPo}
                                getOptionLabel={(option) => option.label}
                                onChange={handlePoChange}
                                renderInput={(params) => <TextField {...params} label="Select PO" />}
                                />

                            </div>
                        </div>
                        </CardBody>
                        </Card> */}
                        <div>
                            <Box sx={{ height: '100%', width: '100%', marginBottom: '10px', marginTop: '10px' }}>
                                <DataGrid
                                    autoHeight
                                    className="table_header_background"
                                    headerClassName="custom-header-cell"
                                    getRowHeight={() => 'auto'}
                                    rows={approvalrows}
                                    columns={columns}
                                    loading={isMount}
                                    initialState={{
                                    }}
                                    pageSizeOptions={[]}
                                    disableRowSelectionOnClick
                                    disableColumnMenu
                                    disableColumnResize={true}
                                    componentsProps={{
                                        cell: {
                                            disableClick: true,
                                        },
                                    }}
                                    sx={{
                                        '& .MuiDataGrid-cell': {
                                            '& .MuiDataGrid-cell--textOverflow': {
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                            },
                                        },
                                    }}
                                />
                            </Box>
                        </div>
                    </div>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default GRN;
